import(/* webpackMode: "eager" */ "/var/www/vhosts/muthueshop.com/httpdocs/src/app/cart/page.tsx");
